
export const EnglishNativeLanguage = {
  "Name": "English (United States)",
  "BCP47": "en-US",
  "Native": "English"
}